import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TagActions, TagActionTypes } from '../_actions/tag.actions';
import { QueryParamsModel } from '../../_base/crud';
import { Tag } from '../_models/tag.model';

// tslint:disable-next-line:no-empty-interface
export interface TagsState extends EntityState<Tag> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedTagId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Tag> = createEntityAdapter<Tag>();

export const initialTagsState: TagsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedTagId: undefined,
  showInitWaitingMessage: true,
});

export function tagsReducer(state = initialTagsState, action: TagActions): TagsState {
  switch (action.type) {
    case TagActionTypes.TagsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedTagId: undefined,
      };
    case TagActionTypes.TagsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case TagActionTypes.TagCreated:
      return adapter.addOne(action.payload.tag, {
        ...state,
        lastCreatedTagId: action.payload.tag.id,
      });

    case TagActionTypes.TagsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case TagActionTypes.TagsPageLoaded: {
      return adapter.addMany(action.payload.tags, {
        ...initialTagsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case TagActionTypes.ThrowTagError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case TagActionTypes.FireTagSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getTagState = createFeatureSelector<TagsState>('tags');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
